import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import VideocamIcon from '@mui/icons-material/Videocam';
import { enqueueSnackbar } from 'notistack';
import { deleteJobById, getAllService, getCoachService } from '../../actions/userAuth';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import DeleteConfirmationDialog from '../ServiceDialogs/DeleteConfirmationDialog';
import { useDispatch, useSelector } from 'react-redux';
export default function CoachServicesStatus() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [addDeactivation, setAddDeactivation] = useState(false);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentServiceId, setCurrentServiceId] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));

    useEffect(() => {
        setLoading(true);
        dispatch(getCoachService({ id: user._id }, (data) => {
            setServices(data.data.data);
            setLoading(false);
        }));
    }, [user, deleteDialog]);

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();


    const data = [
        { id: 1, header1: 'Ackrolix Innovation', header2: 'Data 2', header3: 'Data 3', header4: '24- April 2023', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'UI UX Designer', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deactivate', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Closing Soon', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deleted', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    const handleDeleteJob = (id) => {
        // var temp = [...jobs];
        // console.log(temp[index]._id);
        // dispatch(deleteJobById(temp[index]._id, {}, (data) => {
        //     temp.splice(index, 1);
        //     setJobs(temp);
        //     enqueueSnackbar("Job deleted successfully", { variant: 'success' });
        // }, (err) => {
        //     enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        // }))

        setAddDeactivation(true);
        setCurrentServiceId(id);
    }




    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
        <Layout>
            <UserLayout userRole={"coach"}>
                <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Service Status</Typography>
                    <TextField
                        sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px #3665D014' }} // Updated style
                        variant="outlined"
                        size="small"
                        placeholder="Search"
                        onChange={handleSearch}
                        InputProps={{
                            endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                        }}
                    />
                </Box>

                <>
                    <Paper sx={{ px: 5, py: 2, boxShadow: 'none', border: '1px solid #e0e0e0' }} >
                        <Grid container my={2} >
                            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                <Typography className='text2Bold'>Filter</Typography>
                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                    className='profile-skills-box text2Light'

                                    value={selectedOption}
                                    onChange={handleChange}
                                >
                                    <option value="">None</option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </Grid>
                            <Grid item md={5}></Grid>

                            <Grid item md={3} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                    className='profile-skills-box text2Light'

                                    value={selectedOption}
                                    onChange={handleChange}
                                >
                                    <option value="">Sort by date</option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </Grid>
                        </Grid >
                        {
                            loading
                                ?
                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                                    <CircularProgress size={24} />
                                </Box>
                                :
                                <Paper sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                                                <Table width="auto">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Service Name
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Medium
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Service Fee
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Active Candidates as on date
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Service Status
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                Action
                                                            </TableCell>


                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? services.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : data
                                                        ).map((row) => (
                                                            <TableRow key={row.id}>
                                                                <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE' }}>
                                                                    <p className='text2Bold' style={{ margin: '0px', cursor: 'pointer' }} onClick={() => navigate('/candidate/job-view')}>{row.serviceName}</p>
                                                                </TableCell>
                                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}><VideocamIcon style={{ color: "#2544EE" }} /></TableCell>
                                                                <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                    {row.enterPrice}
                                                                </TableCell>
                                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE', fontWeight: 'bold' }}>{row?.activeCandidates != undefined ? row?.activeCandidates : 0}</TableCell>
                                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE', fontWeight: 'bold' }}>{row?.serviceStatus}</TableCell>
                                                                <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                    <Box sx={{ display: 'flex' }} >
                                                                        <IconButton aria-label="View" onClick={() => navigate(`/coach/services-status/${row._id}`)}>
                                                                            <Visibility sx={{ color: '#2544EE' }} />
                                                                        </IconButton>
                                                                        <IconButton aria-label="Edit">
                                                                            <Edit sx={{ color: '#2544EE' }} onClick={() => navigate(`/coach/edit-services/${row._id}`)} />
                                                                        </IconButton>
                                                                        <IconButton aria-label="Delete" onClick={() => handleDeleteJob(row._id)}>
                                                                            <Delete sx={{ color: '#2544EE' }} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}

                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={8} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                        component="div"
                                        count={data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Paper>
                        }
                    </Paper>
                </>
            </UserLayout>
            <DeleteConfirmationDialog
                id={currentServiceId}
                addDeactivation={addDeactivation}
                setAddDeactivation={setAddDeactivation}
                setDeleteDialog={setDeleteDialog}
                deleteDialog={deleteDialog}
            />
        </Layout>
    );
}
